var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"w-full",attrs:{"data-t-name":"footer"}},[_c('FooterJubilee'),_vm._v(" "),_c('FooterUpperSection',{attrs:{"footer-social-media-elements":_vm.footerSocialMediaElements}}),_vm._v(" "),_c('FooterLowerSection',{attrs:{"footer-nav-links":_vm.footerNavLinks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }